import aggiungi from "./aggiungi";
import aggiungiDilazione from "./aggiungi-dilazione";
import estrattoConto from "./estratto-conto";
import estrattoContoCsv from "./estratto-conto-csv";
import estrattoContoGenerale from "./estratto-conto-generale";
import estrattoContoDettagliato from "./estratto-conto-dettagliato";
import storna from "./storna";
import sincronizzaAgyo from "./sincronizza-agyo";
import inoltraAgyo from "./inoltra-agyo";
import inviaPreavvisi from "./invia-preavvisi";
import messaInMora from "./messa-in-mora";
import registroIva from "./registro-iva";
import bollettinoClienteSaldo from "./bollettino-cliente-saldo";
import bollettinoCliente from "./bollettino-cliente";
import pdf from "./pdf";
import pdfDettaglio from "./pdf-dettaglio";
import pdfDettaglioEsteso from "./pdf-dettaglio-esteso";
import modificaMassivaDati from "./modifica-massiva-dati";
import riepilogoCicloMesi from "./riepilogo-ciclo-mesi";
import exportDAR from "./export-dar";
import checkSddXml from "./check-sdd-xml";
import quietanza from "./quietanza";
import invioFattureEmail from "./invio-fatture-email";
import importCompensazioni from "./import-compensazioni";

export default [
  // always
  {
    key: "fatture-vendita-button-aggiungi",
    label: "AGGIUNGI FATTURA",
    classCss: "p-button-secondary",
    icon: " pi pi-plus",
    type: "operation",
    method: aggiungi,
    display: "always",
  },
  {
    key: "fatture-vendita-export-domestici-aziende-rappresentanti",
    label: "EXPORT D.A.R.",
    classCss: "p-button-secondary",
    icon: "pi pi-download",
    type: "operation",
    method: exportDAR,
    display: "always",
  },
  {
    key: "fatture-vendita-check-sdd-xml",
    label: "CHECK FLUSSO SDD",
    iconPos: "right",
    cclassCss: "p-button-secondary",
    icon: "pi pi-check",
    type: "operation",
    method: checkSddXml,
    display: "always",
  },
  {
    key: "fatture-vendita-import-compensazioni",
    label: "IMPORTA COMPENSAZIONI",
    iconPos: "right",
    classCss: "p-button-secondary",
    icon: "pi pi-file-import",
    type: "operation",
    method: importCompensazioni,
    display: "always",
  },
  // on-data-filtered
  {
    key: "fatture-vendita-button-riepilogo-ciclo-mese",
    label: "RIEPILOGO CICLO MESI",
    classCss: "p-button-success",
    icon: " pi pi-book",
    type: "operation",
    method: riepilogoCicloMesi,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-estratto-conto",
    label: "ESTRATTO CONTO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: estrattoConto,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-estratto-conto-csv",
    label: "ESTRATTO CONTO CSV",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: estrattoContoCsv,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-estratto-conto-generale",
    label: "ESTRATTO CONTO GENERALE",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: estrattoContoGenerale,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-estratto-conto-dettagliato",
    label: "ESTRATTO CONTO DETTAGLIATO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: estrattoContoDettagliato,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-aggiungi-dilazione",
    label: "AGGIUNGI DILAZIONE",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: aggiungiDilazione,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-storna",
    label: "STORNA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: storna,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-sincronizza-agyo",
    label: "SINCRONIZZA AGYO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: sincronizzaAgyo,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-inoltra-agyo",
    label: "INOLTRA AGYO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: inoltraAgyo,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-invia-preavvisi",
    label: "INVIA PREAVVISI",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: inviaPreavvisi,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-messa-in-mora",
    label: "MESSA IN MORA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: messaInMora,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-registro-iva",
    label: "REGISTRO IVA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: registroIva,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-bollettino-cliente-saldo",
    label: "BOLLETTINO CLIENTE SALDO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: bollettinoClienteSaldo,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-bollettino-cliente",
    label: "BOLLETTINO CLIENTE",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: bollettinoCliente,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-pdf",
    label: "PDF FATTURA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: pdf,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-pdf-dettaglio",
    label: "PDF FATTURA - DETTAGLIO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: pdfDettaglio,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-button-pdf-dettaglio-esteso",
    label: "PDF FATTURA - DETTAGLIO ESTESO",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: pdfDettaglioEsteso,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-modifica-massiva-dati",
    label: "MODIFICA MASSIVA DATI",
    classCss: "p-button-secondary",
    icon: "pi pi-directions",
    type: "operation",
    method: modificaMassivaDati,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-quietanza",
    label: "CREA QUIETANZA",
    classCss: "p-button-secondary",
    icon: "pi pi-directions",
    type: "operation",
    method: quietanza,
    display: "on-data-filtered",
  },
  {
    key: "fatture-vendita-invio-email",
    label: "INVIA FATTURE PER EMAIL",
    classCss: "p-button-secondary",
    icon: "pi pi-send",
    type: "operation",
    method: invioFattureEmail,
    display: "on-data-filtered",
  },
];
